import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-take-customer-webcam-photo-modal',
  templateUrl: './take-customer-webcam-photo-modal.component.html',
  styleUrls: ['./take-customer-webcam-photo-modal.component.css']
})
export class TakeCustomerWebcamPhotoModalComponent {
  @Input() imageCapturedCallback: (image: WebcamImage) => undefined;

  public errorMessage = '';
  public takeImageObservable = new Subject<void>();

  constructor(
    public activeModal: NgbActiveModal,
  ){}

  public handleImageCapture(image: WebcamImage): void {
    this.imageCapturedCallback(image);
    this.activeModal.close();
  }

  public handleWebcamInitError(error: WebcamInitError): void {
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
     this.errorMessage = 'Could not access camera. Please try again and ensure you grant this page access to the camera.';
    } else {
     this.errorMessage ='Could not access camera. Please try again.';
    }
  }

  public handleSave() {
    this.takeImageObservable.next();
  }
}
